import { render, staticRenderFns } from "./SignosVitales.vue?vue&type=template&id=d37236e0&scoped=true"
import script from "./SignosVitales.vue?vue&type=script&lang=js"
export * from "./SignosVitales.vue?vue&type=script&lang=js"
import style0 from "./SignosVitales.vue?vue&type=style&index=0&id=d37236e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37236e0",
  null
  
)

export default component.exports